// extracted by mini-css-extract-plugin
module.exports = {"root":"T_b9","full-width":"T_dH","fullWidth":"T_dH"};